import React from 'react';

export const menuItems = [{
    id: 'uitleg',
    name: 'Uitleg'
}, {
    id: 'colofon',
    name: 'Colofon'
}];

export const modalItems = {
  uitleg: {
    title: 'Wat is de Krachtenveldanalyse?',
    text: <div>

          <p>Het denkgereedschap Krachtenveldanalyse maakt het mogelijk snel overzicht en inzicht te verkrijgen in de waardering van spelers voor twee verschillende facetten van een bepaald vraagstuk of voorstel. Je gebruikt het gereeedschap als volgt:</p>
          <ol>
          <li>Geef de krachtenveldanalyse een titel<br />
          Bijvoorbeeld: 'Waardering maatregel XYZ'</li>

          <li>Vul het label voor de x-as in<br />
          Bijvoorbeeld: 'Waardering voor doel'</li>

          <li>Vul het label voor de y-as in<br />
          Bijvoorbeeld: 'Waardering voor uitvoering'</li>

          <li>Vul 'label assen' in<br />
          Bijvoorbeeld: 'Rapportcijfer (1-10)'</li>

          <li>Voeg spelers toe door<br />
          - op het plusteken (+) te drukken<br />
          - spelers een naam te geven<br />
          - spelers een kleur te geven (bijv. blauw voor rijksoverheid, geel voor bedrijven, ...)<br />
          - voor spelers de grootte van de bol te bepalen (invloedrijke spelers krijgen een grote bol, minder invloedrijke spelers een kleinere)<br />
          Bijvoorbeeld Speler 1: 'Ministerie van BZK, blauw, bolgrootte 6'</li>

          <li>Bepaal de scores per speler op de x- respectievelijk y-as<br />
          Bijvoorbeeld: Ministerie van BZK geeft een 8 voor het doel en een 9 voor de uitvoering: (8, 9)</li>

          <li>Schuif alle bollen naar de goede plek op het grid<br />
          Bijvoorbeeld: Ministerie van BZK met score (8,9) komt op het achtste (dunne) streepje van links en het negende (dunne) streepje van onderen.</li>

          <li>En klaar is het krachtenveld!<br />
          Je kunt het resultaat bewaren, openen en/of printen via het 'hamburgermenu' rechtsboven in het scherm.</li>
          </ol>
      </div>
    },
  colofon: {
    title: 'Wie heeft de Krachtenveldanalyse gemaakt?',
    text:
    <div>
        <p>Dit denkgereedschap is een product van De Argumentenfabriek dat we in 2017 hebben ontwikkeld.</p>
        <p>Heb je vragen of opmerkingen over dit denkgereedschap? Stuur ons gerust een <a href="mailto:secretariaat@argumentenfabriek.nl">e-mail</a>, we stellen feedback zeer op prijs.</p>
   </div>
  }
}



// WEBPACK FOOTER //
// ./src/data/menu.js